import { gql } from "@apollo/client";

export default gql`
  mutation SetGovernmentAwards($governmentId: ObjectId!, $awards: [ObjectId!]!) {
    setGovernmentAwards(governmentId: $governmentId, awards: $awards) {
      _id
      awards {
        _id
        name
      }
    }
  }
`;
